var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2069 19.6712C26.0407 15.223 25.5156 9.25219 21.6317 5.36827C17.1407 0.877243 9.8593 0.877243 5.36827 5.36827C0.877243 9.8593 0.877243 17.1407 5.36827 21.6317C9.25223 25.5157 15.2232 26.0407 19.6714 23.2068L25.5209 29.0563C26.302 29.8374 27.5683 29.8374 28.3494 29.0563L29.0565 28.3492C29.8375 27.5682 29.8375 26.3018 29.0565 25.5208L23.2069 19.6712ZM18.8033 8.1967C21.7322 11.1256 21.7322 15.8744 18.8033 18.8033C15.8744 21.7322 11.1256 21.7322 8.1967 18.8033C5.26777 15.8744 5.26777 11.1256 8.1967 8.1967C11.1256 5.26777 15.8744 5.26777 18.8033 8.1967Z",
    fill: "currentColor"
  })));
};
export default SvgSearch;